import React from "react";
import { motion } from "framer-motion";
import { BookOpen, Building2, ClipboardList } from "lucide-react";

const InterventionDomainsSection = () => {
  const domains = [
  {
    icon: <BookOpen className="w-10 h-10 stroke-[1.5]" />,
    title: "Formation & Renforcement",
    description:
    "Programmes structurés de développement des compétences pour cadres et équipes institutionnelles, incluant formations certifiantes."
  },
  {
    icon: <Building2 className="w-10 h-10 stroke-[1.5]" />,
    title: "Accompagnement Institutionnel",
    description:
    "Appui stratégique aux organisations publiques dans leurs processus de transformation digitale et modernisation administrative."
  },
  {
    icon: <ClipboardList className="w-10 h-10 stroke-[1.5]" />,
    title: "Études & Conseil Stratégique",
    description:
    "Analyses approfondies et audits organisationnels pour l\'optimisation des performances et l\'innovation institutionnelle."
  }];


  return (
    <section className="py-24 relative overflow-hidden bg-white">
      {/* Fond subtil */}
      <div className="absolute inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-20"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header - Plus épuré */}
        <div className="text-center mb-20">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-[#96121D] font-bold tracking-[0.2em] uppercase text-xs mb-4 block">

            Notre Expertise
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-3xl md:text-5xl font-light text-gray-900 mb-6">

            Nos Domaines d'<span className="font-black">Intervention</span>
          </motion.h2>
          <div className="w-12 h-1 bg-[#9B8E57] mx-auto rounded-full"></div>
        </div>

        {/* Hero Image - Style "Floating" */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="mb-24">

          <div className="relative group rounded-[2rem] overflow-hidden shadow-2xl border border-gray-100">
            <img
              src="https://img.rocket.new/generatedImages/rocket_gen_img_162b823fc-1765171876567.png"
              alt="Collaboration stratégique"
              className="w-full h-[350px] md:h-[450px] object-cover transition-transform duration-1000 group-hover:scale-105" />

            <div className="absolute inset-0 bg-gradient-to-tr from-black/40 via-transparent to-transparent"></div>
          </div>
        </motion.div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {domains?.map((domain, index) =>
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            viewport={{ once: true }}
            className="group relative flex flex-col items-center text-center p-2">

              {/* Icône Minimaliste */}
              <div className="mb-8 relative">
                <div className="w-20 h-20 flex items-center justify-center rounded-2xl bg-gray-50 text-[#9B8E57] transition-all duration-500 group-hover:bg-[#96121D] group-hover:text-white group-hover:rotate-6 group-hover:shadow-xl group-hover:shadow-[#96121D]/20">
                  {domain?.icon}
                </div>
                {/* Petit cercle décoratif */}
                <div className="absolute -bottom-2 -right-2 w-6 h-6 bg-[#9B8E57]/20 rounded-full blur-sm opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>

              {/* Contenu */}
              <h3 className="text-xl font-bold text-gray-900 mb-4 transition-colors group-hover:text-[#96121D]">
                {domain?.title}
              </h3>
              <p className="text-gray-500 leading-relaxed font-light text-sm md:text-base">
                {domain?.description}
              </p>
              
              {/* Ligne décorative discrète au survol */}
              <div className="mt-6 w-0 h-0.5 bg-[#96121D] transition-all duration-500 group-hover:w-12"></div>
            </motion.div>
          )}
        </div>
      </div>
    </section>);



};

export default InterventionDomainsSection;